import React from 'react'
import {config} from './base'
import {FieldInput} from './field_input'
import {buildDecoration} from './build_decoration'

const STYLES = {
	left: {
		layout: {alignSelf: 'flex-start'},
		label: {fontSize: 12, color: 'dark-grey'},
	},
	right: {
		layout: {alignSelf: 'center'},
		label: {fontSize: 14, color: 'black'},
	},
}

export const LeftContent = props => {
	const {inputPosition = 'left'} = props
	const styles = STYLES[inputPosition]

	return (
		<config.Layout direction="vertical" className="form-field-content-left" style={styles.layout}>
			<Label {...props} {...styles.label} />
			{inputPosition === 'left' && <FieldInput {...props} />}
			<ValidationError {...props} />
		</config.Layout>
	)
}

const Label = ({color, fontSize, ...props}) => {
	const {required, readOnly, disabled, infoIconMessage} = props
	const label = buildDecoration({...props, decorationType: 'label'})
	const extraLabel = buildDecoration({
		...props,
		decorationType: 'extraLabel',
	})

	// use title and body directly from infoIconMessage prop, or use decorationTypes
	const _infoIconMessage = infoIconMessage && {
		title: buildDecoration({'popout.title': true, ...props, decorationType: 'popout.title'}),
		body: buildDecoration({'popout.body': true, ...props, decorationType: 'popout.body'}),
		...infoIconMessage,
	}

	const showRequired = !readOnly && !disabled
	return (
		<>
			<config.Text truncate infoIconMessage={_infoIconMessage} color={color} fontSize={fontSize}>
				{label} {showRequired && required && '*'}
			</config.Text>
			{extraLabel && (
				<config.Text truncate color={color} fontSize={fontSize}>
					{extraLabel}
				</config.Text>
			)}
		</>
	)
}

const ValidationError = ({error}) => {
	return (
		<config.Text fontSize={12} color="medium-red">
			{error}
		</config.Text>
	)
}
